// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';

const FooterBannerVendi: React.FC = () => {
    const { t } = useTranslation();
    const bannerTitle = t('homePage.footerBanner.title');

    return (
        <section className="py-5 bg-primary">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-9">
                        <h2 className="text-white mb-0">{bannerTitle}</h2>
                    </div>
                    <div className="col-lg-3 text-lg-right mt-3 mt-lg-0">
                        <Link className="btn btn-white" to="/vendi" title={bannerTitle}>
                            {t('homePage.footerBanner.cta')}
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FooterBannerVendi;